import { Validators } from '../../core/validators/validator.constant';

export class InputValidators {
  checkPincode(pincode: string) {
    return Validators.PINCODE_REGEX.test(pincode);
  }
}
